<template>
  <div class="glass-card p-6 rounded-xl border border-slate-700">
    <h2 class="text-xl font-bold text-white mb-4 flex items-center gap-2">
      <i class="ph-bold ph-user-plus text-blue-400"></i>
      新增运维管理员
    </h2>
    <div class="grid grid-cols-2 gap-4">
      <input
        v-model="form.username"
        type="text"
        placeholder="用户名"
        class="px-3 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-blue-500"
      />
      <input
        v-model="form.password"
        type="password"
        placeholder="密码"
        class="px-3 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-blue-500"
      />
      <input
        v-model="form.name"
        type="text"
        placeholder="姓名"
        class="px-3 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-blue-500"
      />
      <input
        v-model="form.phone"
        type="text"
        placeholder="电话"
        class="px-3 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-blue-500"
      />
      <input
        v-model="form.email"
        type="email"
        placeholder="邮箱"
        class="px-3 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-blue-500 col-span-2"
      />
    </div>
    <button
      @click="$emit('create')"
      class="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-500 transition"
    >
      创建运维管理员
    </button>
    <p v-if="errorMessage" class="mt-2 text-sm text-red-400">{{ errorMessage }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  newOp: {
    type: Object,
    required: true
  },
  errorMessage: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:new-op', 'create']);

// 双向绑定辅助，避免父子同步丢失
const form = computed({
  get: () => props.newOp || {},
  set: (val) => emit('update:new-op', val)
});
</script>

